import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import LoginForm from './Components/LoginForm';
import Restaurant from './Pages/Restaurant';
import { buildTavolataAccess } from './utils/restaurantPermissions';

function readJson(key) {
  try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; }
}

function loadSession() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const tenant = readJson('tenant');
  const user = readJson('user');
  if (!token || !tenant) return null;
  return { token, tenant, user };
}

export default function App() {
  const [session, setSession] = useState(loadSession);
  const required = process.env.REACT_APP_RESTAURANT_PERMISSION || 'restaurant:terminal:ver';
  const allowCompat = String(process.env.REACT_APP_ALLOW_PDV_PERMISSION_COMPAT || '').toLowerCase() === 'true';

  useEffect(() => {
    const expired = () => setSession(null);
    window.addEventListener('integranube:session-expired', expired);
    return () => window.removeEventListener('integranube:session-expired', expired);
  }, []);

  const access = useMemo(() => {
    if (!session) return { app: false };
    const next = buildTavolataAccess(session.tenant);
    if (!next.app && allowCompat) {
      const set = new Set(Array.isArray(session.tenant?.permissions) ? session.tenant.permissions : []);
      if (set.has('pdv:terminal:ver')) return { ...next, app: true, salon: true, anfitrion: true, mesero: true, pedidos: true, cocina: true, caja: true, defaultPath: '/salon', defaultView: 'salon' };
    }
    return next;
  }, [allowCompat, session]);

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tenantid');
    localStorage.removeItem('tenant');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    setSession(null);
  };

  if (!session) return <LoginForm onLogin={(next) => setSession(next)} />;

  if (!access.app) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#edf3f8', display: 'grid', placeItems: 'center', p: 2 }}>
        <Paper elevation={0} sx={{ width: 'min(560px,100%)', p: 3, border: '1px solid #d7e1ec' }}>
          <Stack spacing={1.5}>
            <Box component="img" src="/tavolata-mark.png" alt="Tavolata" sx={{ width: 64, height: 64 }} />
            <Typography variant="h5" fontWeight={950}>Tavolata</Typography>
            <Alert severity="warning">El perfil no tiene el permiso <strong>{required}</strong>.</Alert>
            <Typography variant="body2" color="text.secondary">
              Cree el permiso para Restaurant y agréguelo al perfil. Para pruebas temporales puede habilitar REACT_APP_ALLOW_PDV_PERMISSION_COMPAT=true.
            </Typography>
            <Button variant="contained" onClick={logout}>Cerrar sesión</Button>
          </Stack>
        </Paper>
      </Box>
    );
  }

  return <Restaurant session={session} access={access} onLogout={logout} />;
}
